var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.tabActiveName,
            callback: function($$v) {
              _vm.tabActiveName = $$v
            },
            expression: "tabActiveName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "地址配置", name: _vm.ADDRESS_SETTING } },
            [
              _c(
                "div",
                { staticClass: "row", attrs: { gutter: 20, align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.shippingVisible = true
                        }
                      }
                    },
                    [_vm._v("\n          新增网点\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _vm.resData
                          ? _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.tableLoading,
                                    expression: "tableLoading"
                                  }
                                ],
                                ref: "multipleTable",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  height: "800",
                                  data: _vm.resData.list,
                                  "tooltip-effect": "dark"
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "shipping_company",
                                    label: "快递公司"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "express_account",
                                    label: "菜鸟账号"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "province",
                                    label: "省"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "city",
                                    label: "市"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "district",
                                    label: "区"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "detail",
                                    label: "详细地址"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "admin_name",
                                    label: "最后操作人员"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "shipping_sender_is_default",
                                    label: "是否默认",
                                    "show-overflow-tooltip": "",
                                    align: "center"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-button", {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-edit",
                                                size: "mini",
                                                circle: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setDefault(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row
                                                    .shipping_sender_is_default
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    951243837
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "shipping_sender_is_default",
                                    label: "退换货默认快递",
                                    "show-overflow-tooltip": "",
                                    align: "center"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-button", {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-edit",
                                                size: "mini",
                                                circle: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setReturnDefault(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getReturnDefaultText(
                                                    scope.row
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    518684325
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "warning",
                                    label: "是否开启预警值通知",
                                    width: "200",
                                    align: "center"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-switch", {
                                              attrs: {
                                                "active-value": "1",
                                                "inactive-value": "0"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.setWarningSwitch(
                                                    $event,
                                                    scope.row
                                                  )
                                                }
                                              },
                                              model: {
                                                value: scope.row.is_warning,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "is_warning",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.is_warning"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-input-number", {
                                              staticStyle: { width: "120px" },
                                              attrs: {
                                                size: "small",
                                                step: 1,
                                                min: 1,
                                                disabled:
                                                  scope.row.is_warning === "0"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.setWarningNum(
                                                    $event,
                                                    scope.row
                                                  )
                                                }
                                              },
                                              model: {
                                                value: scope.row.warning_num,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "warning_num",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.warning_num"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1668954268
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { label: "操作", align: "center" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.beforeSetSender(
                                                      scope.row.cpcode,
                                                      scope.row.id,
                                                      scope.row
                                                        .express_account_id,
                                                      2
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "修改\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  size: "small",
                                                  disabled:
                                                    scope.row.is_default ===
                                                    _vm.IS_DEFAULT_YES
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDeleteSender(
                                                      scope
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "删除\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3343566077
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "顺丰快递配置", name: _vm.SF_EXPRESS_SETTING } },
            [
              _c(
                "div",
                { staticClass: "row", attrs: { gutter: 20, align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleAddSfExpress }
                    },
                    [_vm._v("\n          新增\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _vm.resSFData
                          ? _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.tableLoading,
                                    expression: "tableLoading"
                                  }
                                ],
                                ref: "multipleTable",
                                attrs: {
                                  height: "800",
                                  data: _vm.resSFData,
                                  "tooltip-effect": "dark"
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "account",
                                    label: "网点号名称"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "weight_type_formal",
                                    label: "包裹预测重量"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "cust_id",
                                    label: "网点月结号"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "express_type_formal",
                                    label: "快递类型"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "province",
                                    label: "省"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "city",
                                    label: "市"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "district",
                                    label: "区"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "detail",
                                    label: "详细地址"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "sender_name",
                                    label: "发货人"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "sender_phone",
                                    label: "发货人电话"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "",
                                    label: "顾客编码"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-button", {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-edit",
                                                size: "mini",
                                                circle: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showDialogAccountCode(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3055813490
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "",
                                    label: "校验码",
                                    "show-overflow-tooltip": "",
                                    align: "center"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-button", {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-edit",
                                                size: "mini",
                                                circle: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showDialogAccountToken(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    841450852
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "is_monthly",
                                    label: "是否月结"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.is_monthly ===
                                                    _vm.IS_MONTHLY_YES
                                                    ? "是"
                                                    : "否"
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1310228967
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "is_default",
                                    label: "是否默认"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.is_default ===
                                                    _vm.IS_DEFAULT_YES
                                                    ? "是"
                                                    : "否"
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1698856295
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "is_deleted",
                                    label: "是否启用"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.is_deleted ===
                                                    _vm.IS_DELETED_YES
                                                    ? "禁用"
                                                    : "启用"
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2387911392
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "is_qr_code",
                                    label: "是否打印二维码面单"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.is_qr_code === "1"
                                                    ? "否"
                                                    : "是"
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    697517810
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { label: "操作", align: "center" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleEditSFExpress(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    编辑\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  size: "small",
                                                  disabled:
                                                    scope.row.is_default ===
                                                    _vm.IS_DEFAULT_YES
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDeleteSender(
                                                      scope
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "删除\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1174730057
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "京东保价配置", name: _vm.Jd_EXPRESS_SETTING } },
            [
              _c(
                "div",
                { staticClass: "row", attrs: { gutter: 20, align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "primary", disabled: true },
                      on: { click: _vm.handleAddJdExpress }
                    },
                    [_vm._v("\n          新增[暂未开放]\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _vm.resJdData
                          ? _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.tableLoading,
                                    expression: "tableLoading"
                                  }
                                ],
                                ref: "multipleTable",
                                attrs: {
                                  height: "800",
                                  data: _vm.resJdData,
                                  "tooltip-effect": "dark"
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "account",
                                    label: "网点号名称"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "cust_id",
                                    label: "月结号"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "detail",
                                    label: "发货地址"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "guarantee_value",
                                    label: "是否判断保价",
                                    "show-overflow-tooltip": "",
                                    align: "center",
                                    formatter: _vm.stateGuaranteeType
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "guarantee_value_amount",
                                    label: "保价金额设置(元)"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { label: "操作", align: "center" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleEditJdExpress(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    编辑\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1927392312
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "请选择地址", visible: _vm.senderVisible },
          on: {
            "update:visible": function($event) {
              _vm.senderVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                [
                  _vm._l(_vm.senders, function(sender_value, sender_key) {
                    return _c(
                      "el-radio",
                      {
                        key: sender_key,
                        staticStyle: { margin: "0 auto" },
                        attrs: { label: sender_key },
                        model: {
                          value: _vm.sender,
                          callback: function($$v) {
                            _vm.sender = $$v
                          },
                          expression: "sender"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(sender_value.province) +
                            "," +
                            _vm._s(sender_value.city) +
                            "," +
                            _vm._s(sender_value.district) +
                            "," +
                            _vm._s(sender_value.detail) +
                            "\n          "
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#ff6297",
                              "font-size": "12px"
                            }
                          },
                          [
                            _vm._v(
                              "(网点名称:" +
                                _vm._s(sender_value.branchName) +
                                ",网点编码:" +
                                _vm._s(sender_value.branchCode) +
                                ",剩余面单数:" +
                                _vm._s(sender_value.quantity) +
                                ")"
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("br")
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.senderVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setSender } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "请选择快递公司", visible: _vm.shippingVisible },
          on: {
            "update:visible": function($event) {
              _vm.shippingVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "快递公司" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择快递公司" },
                      on: {
                        change: function($event) {
                          return _vm.beforeSetSender("", 0, "")
                        }
                      },
                      model: {
                        value: _vm.form.cpcode,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cpcode", $$v)
                        },
                        expression: "form.cpcode"
                      }
                    },
                    _vm._l(_vm.resData.shipping_company, function(item) {
                      return _c("el-option", {
                        key: item.cniao,
                        attrs: {
                          label: item.shipping_company,
                          value: item.cniao
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "菜鸟/网点账号" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "菜鸟/网点账号" },
                      on: {
                        change: function($event) {
                          return _vm.beforeSetSender("", 0, "")
                        }
                      },
                      model: {
                        value: _vm.form.express_account_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "express_account_id", $$v)
                        },
                        expression: "form.express_account_id"
                      }
                    },
                    _vm._l(_vm.resData.account, function(item) {
                      return _c("el-option", {
                        key: item.express_account_id,
                        attrs: {
                          label: item.account,
                          value: item.express_account_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.shippingVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setSender } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "修改顾客编码", visible: _vm.showAccountCode },
          on: {
            "update:visible": function($event) {
              _vm.showAccountCode = $event
            },
            close: _vm.handleResetAccountCode
          }
        },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入顾客编码" },
            model: {
              value: _vm.accountCode,
              callback: function($$v) {
                _vm.accountCode = $$v
              },
              expression: "accountCode"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showAccountCode = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSubmitAccountCode }
                },
                [_vm._v("\n        确 定\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "修改校验码", visible: _vm.showAccountToken },
          on: {
            "update:visible": function($event) {
              _vm.showAccountToken = $event
            },
            close: _vm.handleResetAccountToken
          }
        },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入校验码" },
            model: {
              value: _vm.accountToken,
              callback: function($$v) {
                _vm.accountToken = $$v
              },
              expression: "accountToken"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showAccountToken = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSubmitAccountToken }
                },
                [_vm._v("\n        确 定\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.sfForm.id ? "修改顺丰快递配置" : "新增顺丰快递配置",
            visible: _vm.showEditSFForm
          },
          on: {
            "update:visible": function($event) {
              _vm.showEditSFForm = $event
            },
            close: _vm.handleResetSFForm
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "sfForm",
              attrs: {
                model: _vm.sfForm,
                rules: _vm.sfFormRules,
                "label-width": "120px"
              }
            },
            [
              _c("el-form-item", { attrs: { label: "网点号名称" } }, [
                _c("div", [_vm._v(_vm._s(_vm.expressLocationName))])
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "包裹预测重量",
                    prop: "weight_type",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择包裹预测重量" },
                      on: { change: _vm.checkHasDefaultTips },
                      model: {
                        value: _vm.sfForm.weight_type,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "weight_type", $$v)
                        },
                        expression: "sfForm.weight_type"
                      }
                    },
                    _vm._l(_vm.weightTypeOption, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "网点月结号", prop: "cust_id" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入网点月结号" },
                    model: {
                      value: _vm.sfForm.cust_id,
                      callback: function($$v) {
                        _vm.$set(_vm.sfForm, "cust_id", $$v)
                      },
                      expression: "sfForm.cust_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "快递类型",
                    prop: "express_type",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择快递类型" },
                      model: {
                        value: _vm.sfForm.express_type,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "express_type", $$v)
                        },
                        expression: "sfForm.express_type"
                      }
                    },
                    _vm._l(_vm.expressTypeOption, function(item) {
                      return _c("el-option", {
                        key: item.express_type,
                        attrs: {
                          label: item.express_type_formal,
                          value: item.express_type
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货地址省份", prop: "province" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      on: { change: _vm.getCity },
                      model: {
                        value: _vm.sfForm.province,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "province", $$v)
                        },
                        expression: "sfForm.province"
                      }
                    },
                    _vm._l(_vm.provinceOptions, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.name, label: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货地址市", prop: "city" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: !_vm.sfForm.province },
                      on: { change: _vm.getDistrict },
                      model: {
                        value: _vm.sfForm.city,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "city", $$v)
                        },
                        expression: "sfForm.city"
                      }
                    },
                    _vm._l(_vm.cityOptions, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.name, label: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货地址区", prop: "district" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", disabled: !_vm.sfForm.city },
                      model: {
                        value: _vm.sfForm.district,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "district", $$v)
                        },
                        expression: "sfForm.district"
                      }
                    },
                    _vm._l(_vm.districtOptions, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.name, label: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货详细地址", prop: "detail" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入发货详细地址",
                      maxlength: "200",
                      "show-word-limit": "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.sfForm.detail,
                      callback: function($$v) {
                        _vm.$set(_vm.sfForm, "detail", $$v)
                      },
                      expression: "sfForm.detail"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货人", prop: "sender_name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入发货人名字",
                      maxlength: "20",
                      "show-word-limit": "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.sfForm.sender_name,
                      callback: function($$v) {
                        _vm.$set(_vm.sfForm, "sender_name", $$v)
                      },
                      expression: "sfForm.sender_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货人电话", prop: "sender_phone" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入发货电话",
                      maxlength: "20",
                      "show-word-limit": "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.sfForm.sender_phone,
                      callback: function($$v) {
                        _vm.$set(_vm.sfForm, "sender_phone", $$v)
                      },
                      expression: "sfForm.sender_phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.sfForm.sender_id
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "cust_code", label: "顾客编码" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入顾客编码" },
                        model: {
                          value: _vm.sfForm.cust_code,
                          callback: function($$v) {
                            _vm.$set(_vm.sfForm, "cust_code", $$v)
                          },
                          expression: "sfForm.cust_code"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.sfForm.sender_id
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "account_token", label: "校验码" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入校验码" },
                        model: {
                          value: _vm.sfForm.account_token,
                          callback: function($$v) {
                            _vm.$set(_vm.sfForm, "account_token", $$v)
                          },
                          expression: "sfForm.account_token"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "是否月结", prop: "is_monthly", required: "" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择是否月结" },
                      model: {
                        value: _vm.sfForm.is_monthly,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "is_monthly", $$v)
                        },
                        expression: "sfForm.is_monthly"
                      }
                    },
                    _vm._l(_vm.monthlyOption, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "是否默认", prop: "is_default", required: "" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择是否默认" },
                      on: { change: _vm.checkHasDefaultTips },
                      model: {
                        value: _vm.sfForm.is_default,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "is_default", $$v)
                        },
                        expression: "sfForm.is_default"
                      }
                    },
                    _vm._l(_vm.defaultOption, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.showHasDefaultTips
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            color: "red",
                            display: "inline-block",
                            "margin-left": "10px"
                          }
                        },
                        [
                          _vm._v(
                            "\n          包裹预测重量已经存在默认选项\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "是否启用", prop: "is_deleted", required: "" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择是否启用" },
                      model: {
                        value: _vm.sfForm.is_deleted,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "is_deleted", $$v)
                        },
                        expression: "sfForm.is_deleted"
                      }
                    },
                    _vm._l(_vm.openOption, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否打印二维码面单",
                    prop: "is_qr_code",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择是否打印" },
                      model: {
                        value: _vm.sfForm.is_qr_code,
                        callback: function($$v) {
                          _vm.$set(_vm.sfForm, "is_qr_code", $$v)
                        },
                        expression: "sfForm.is_qr_code"
                      }
                    },
                    _vm._l(_vm.printOptions, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showEditSFForm = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingSubmitSFForm },
                  on: { click: _vm.handleSubmitSFForm }
                },
                [_vm._v("\n        确 定\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.jdForm.id ? "修改京东快递配置" : "新增京东快递配置",
            visible: _vm.showEditJdForm
          },
          on: {
            "update:visible": function($event) {
              _vm.showEditJdForm = $event
            },
            close: _vm.handleResetJdForm
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "jdForm",
              attrs: {
                model: _vm.jdForm,
                rules: _vm.jdFormRules,
                "label-width": "140px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "网点号名称", prop: "account" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入网点号名称", disabled: true },
                    model: {
                      value: _vm.jdForm.account,
                      callback: function($$v) {
                        _vm.$set(_vm.jdForm, "account", $$v)
                      },
                      expression: "jdForm.account"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "月结号", prop: "cust_id" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入月结号" },
                    model: {
                      value: _vm.jdForm.cust_id,
                      callback: function($$v) {
                        _vm.$set(_vm.jdForm, "cust_id", $$v)
                      },
                      expression: "jdForm.cust_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货地址", prop: "detail" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入发货地址" },
                    model: {
                      value: _vm.jdForm.detail,
                      callback: function($$v) {
                        _vm.$set(_vm.jdForm, "detail", $$v)
                      },
                      expression: "jdForm.detail"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否判断保价", prop: "guarantee_value" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择是否保价" },
                      model: {
                        value: _vm.jdForm.guarantee_value,
                        callback: function($$v) {
                          _vm.$set(_vm.jdForm, "guarantee_value", $$v)
                        },
                        expression: "jdForm.guarantee_value"
                      }
                    },
                    _vm._l(_vm.guaranteeOption, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.name, value: item.key }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "保价金额设置(元)",
                    prop: "guarantee_value_amount"
                  }
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      disabled: _vm.jdForm.guarantee_value === _vm.GUARANTEE_NO,
                      precision: 2,
                      step: 0.1,
                      min: 0,
                      max: 1000000
                    },
                    model: {
                      value: _vm.jdForm.guarantee_value_amount,
                      callback: function($$v) {
                        _vm.$set(_vm.jdForm, "guarantee_value_amount", $$v)
                      },
                      expression: "jdForm.guarantee_value_amount"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showEditJdForm = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingSubmitJdForm },
                  on: { click: _vm.handleSubmitJdForm }
                },
                [_vm._v("\n        确 定\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b6cadfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6cadfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/WavePickingSender.vue
// module id = null
// module chunks = 